import { message } from "antd";
import { rawDataApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";
import { RECOMMENDATION } from "../constants/url";
import { setLocalStorage } from "../utils/localStorage";

export const submitRecommendationApi = ({ data, successCallback }) => {
  return (dispatch) => {
    let url = RECOMMENDATION;
    rawDataApiCall({ url: url, method: "POST", data: data })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
          setLocalStorage(
            "recommendation_value",
            responseJson?.data?.recommendation_value
          );

          message.success(responseJson?.message);
        } else {
          message.error(responseJson?.message);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        // finalCallback();
      });
  };
};
